import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { isCountPageHost } from './hosts';

// Two front ends on the same API: the staff app at /, the count page (CountAdviser; SmartCount until 2026-10-25) at
// /simple and on its own host countadviser.* (hosts.ts; docs/simple-count-page-plan.md). Each loads its own style
// sheet, so they never mix.
// abacuslens.com and www: the landing page (sign-in, then a tile per app).
const host = window.location.hostname;
const landing = host === 'abacuslens.com' || host === 'www.abacuslens.com';
const simple = isCountPageHost(host)
  || window.location.pathname === '/simple' || window.location.pathname.startsWith('/simple/');
const report = window.location.pathname === '/report';      // the slowness report (administrators)

// CountAdviser installs to a phone's home screen (docs/mobile-app-options.md): its own manifest (its own host opens at /,
// the test site at /simple; ?signin goes straight to sign-in), icon and colors. index.html is shared by every host, so
// they are added here. File names carry a version: the server caches files other than index.html for a year.
if (simple) {
  const own = isCountPageHost(host);
  const add = (tag: string, attrs: Record<string, string>) =>
    document.head.appendChild(Object.assign(document.createElement(tag), attrs));
  add('link', { rel: 'manifest', href: own ? '/countadviser-1.webmanifest' : '/countadviser-simple-1.webmanifest' });
  add('link', { rel: 'apple-touch-icon', href: '/countadviser-icon-180.png' });
  add('meta', { name: 'apple-mobile-web-app-title', content: 'CountAdviser' });
  add('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' });
  add('meta', { name: 'mobile-web-app-capable', content: 'yes' });
  add('meta', { name: 'theme-color', content: '#1f5f8b' });
}
const Page = report ? lazy(() => import('./report/TimingReport'))
           : landing ? lazy(() => import('./landing/Landing'))
           : simple ? lazy(() => import('./simple/SimpleApp'))
                    : lazy(() => import('./App'));          // App.tsx imports styles.css

createRoot(document.getElementById('root')!).render(<StrictMode><Suspense fallback={null}><Page /></Suspense></StrictMode>);
